import React from "react";
import "material-symbols/outlined.css";
import classNames from "classnames";

const SingleCheckbox = ({
  label,
  isLink = false,
  link = "",
  className,
  checked,
  setChecked,
  disabled,
}) => {
  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
  };

  return (
    <label
      className={classNames(
        "flex items-center gap-x-3 cursor-pointer",
        className,
        disabled && "opacity-[0.7] pointer-events-none"
      )}
    >
      <div className="relative flex items-center">
        <input
          type="checkbox"
          checked={checked}
          onChange={handleCheckboxChange}
          className="peer appearance-none w-5 h-5 border border-[#C6CCE8] rounded-md shrink-0 checked:bg-blue checked:border-0"
          disabled={disabled}
        />
        <span className="select-none cursor-pointer material-symbols-outlined absolute shrink-0 text-white scale-75 -left-0.5 peer-checked:text-white">
          check
        </span>
      </div>
      <span className="text-light">
        {label}{" "}
        {isLink && (
          <span>
            <a href={link} className="text-[#016db8]">
              terms and conditions
            </a>
            <span className="material-symbols-outlined text-[#595f77] align-bottom px-1 scale-75">
              open_in_new
            </span>
          </span>
        )}
      </span>
    </label>
  );
};

export default SingleCheckbox;
